import { Button, ButtonMode, ButtonSize, DataItemFormatter } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import { NotificationMode } from '../../../../../../models/Preference';
import styles from './AlertModeRenderer.module.scss';

const cx = classNames.bind(styles);

const AlertModeRenderer: DataItemFormatter<NotificationMode, ReactElement, { onChange: Function }> = ({
  value,
  props,
  row,
}) => {
  const { index } = row;
  const onButtonClick = (mode: NotificationMode) => {
    if (value === mode) {
      return;
    }

    props?.onChange(mode, index);
  };

  const renderAlertModeButton = (mode: NotificationMode) => {
    return (
      <Button
        className={cx('alert', { active: value === mode })}
        mode={ButtonMode.TERTIARY}
        size={ButtonSize.SMALL}
        onClick={() => onButtonClick(mode)}
      >
        {mode}
      </Button>
    );
  };

  return (
    <div className={cx('body')}>
      {renderAlertModeButton(NotificationMode.Digest)}
      {renderAlertModeButton(NotificationMode.Instant)}
      {renderAlertModeButton(NotificationMode.None)}
    </div>
  );
};

export default AlertModeRenderer;
